import { HeroImmersive, MarqueeRibbon, ObjetDArt, WhoWeAre, ScienceInteractive, AnatomySpecs, MassiveQuote, TheProof, ClinicalEvidence, DesignStory, TrustStrip, FinalConversion } from "@/components/home/HomeLuxe";
import { Testimonials } from "@/components/home/Testimonials";

export default function Home() {
  return (
    <div data-testid="home-page">
      <HeroImmersive />
      <MarqueeRibbon />
      <ObjetDArt />
      <WhoWeAre />
      <ScienceInteractive />
      <AnatomySpecs />
      <MassiveQuote />
      <TheProof />
      <ClinicalEvidence />
      <DesignStory />
      <Testimonials />
      <TrustStrip />
      <FinalConversion />
    </div>
  );
}
